import React from "react";
import ComponentHeader from "../CommonComponents/componentHeader";
import ThirdPartyTableSection from "../Billing/thirdPartyTableSection";
import UsageTableSection from "../Billing/usageTableSection";
import StoreUsageTableSection from "./storeUsageTableSection";

export const USAGE_COMPONENT = "USAGE_COMPONENT";

const UsageWrapper = () => {
    return (
        <>
            <ComponentHeader title={"Usage"}/>
            <div className="mt-0">
                <StoreUsageTableSection/>
            </div>
        </>
    )
}

export default UsageWrapper;
